module.exports = __webpack_public_path__ + "static/media/mv_ribbon.6943ed94.svg";